import type { DatePickerMode } from '../types';

// Default date formats for different modes. Typed with explicit keys (via
// `satisfies`) so `DEFAULT_DATE_FORMATS.single` is a known, non-optional
// property — callers can use it as a fallback without a non-null assertion.
export const DEFAULT_DATE_FORMATS = {
  single: 'MM/dd/yyyy',
  range: 'MM/dd/yyyy',
  time: 'hh:mm a',
  'single-time': 'MM/dd/yyyy hh:mm a',
} satisfies Record<DatePickerMode, string>;

// Local midnight on 1 January of year 1. A date string would be UTC midnight,
// which is still year 0 west of Greenwich, and `new Date(1, 0, 1)` is 1901.
const startOfYearOne = new Date(0);
startOfYearOne.setFullYear(1, 0, 1);
startOfYearOne.setHours(0, 0, 0, 0);

// Default minimum and maximum dates
export const DEFAULT_MIN_DATE = startOfYearOne;
export const DEFAULT_MAX_DATE = new Date(
  new Date().setFullYear(new Date().getFullYear() + 100),
);
